import { ENUM } from "../helpers/constants/enum";
import { getCity, getIsUseFlowThai, getProvince, getSubDistrictByLabel, getSubDistrictThaiByLabel } from "../helpers/functions/data";

export class ModelAddress {
  constructor(props = {}) {
    props = props || {};

    this.address = props.address_text;

    // CR: Enhance location address
    // this.selectedProvince = props.address_type === ENUM.COUNTRY_TYPE.LAOS ? props.province || '' : getProvince(props.province);
    // this.selectedCity = props.address_type === ENUM.COUNTRY_TYPE.LAOS ? props.city || '' : getCity(props.city);
    this.selectedProvince = getProvince(props.province);
    this.selectedCity = getCity(props.city);
    this.district = props.district;

    this.subDistrict = props.sub_district || '';

    if (props.address_type === ENUM.COUNTRY_TYPE.THAI) {
      this.subDistrict = getSubDistrictThaiByLabel(this.subDistrict, this.selectedCity);
    }
    // else if (getIsUseFlowThai(props.address_type)) {
    //   this.subDistrict = getSubDistrictByLabel(this.subDistrict, this.selectedCity, this.selectedProvince);

    // }

    this.alley = props.alley;
    this.group = props.group;
    this.street = props.street;
    this.ward = props.ward;
    this.addressType = props.address_type;
  }
}